import {UserModel} from './UserModel';

export class EmailTemplateModel {
  id: number;
  name: string;
  subject: string;
  body: string;

  mailingList: UserModel[];
  userListByTemplate: UserModel[];
  dateListByTemplate: Date[];
}
